import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'layout-top',
    template: '<ng-content></ng-content>',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutTopComponent {}
